import { html, Component } from 'htm/preact';

import * as Tracking from '../tracking';

import Modal from './Modal';

const ClosingDown = () => html`
  <h2 class="listed-title">😰 Listed is Ending Soon! 😰</h2>

  <!-- <section class="modal__section">
    <p>
      <b>
        Hey ${' '}
        <i>you</i>
        ,
      </b>
      ${' '} whether this is your first game or your thousandth, thanks so much for playing this
      game.
    </p>
  </section> -->
  <section class="modal__section">
    <p>
      <b>When?</b>
      ${' '} Our last game is Listed #1000 (!!), on ${' '}
      <i>May 23.</i>
    </p>
  </section>
  <section class="modal__section">
    <p>
      <b>What?</b>
      ${' '} New properties won't be added to our database.
      <br />
      We'll probably maintain the games in our archive.
    </p>
  </section>
  <section class="modal__section">
    <p>
      <b>Why?</b>
      ${' '} Apart from the ~$30/month to run our servers, you may not know that ${' '}
      <i>each week</i>
      ${' '} one of the two of us lovingly curates all 21 properties that appear in the upcoming
      week's games.
    </p>
  </section>
  <section class="modal__section">
    <p>
      <b>Also,</b>
      ${' '} Potch is embarking on a Very Exciting™ journey to try to become a ${' '}
      <i>financially</i>
      ${' '}successful independent game developer. Follow along at${' '}
      <a
        title="potch.me"
        href="https://potch.me/"
        target="_blank"
        onClick=${() => Tracking.clickBio('potch')}
      >
        potch.me
      </a>
      .
    </p>
  </section>
  <section class="modal__section">
    <p>
      <b>Can I do anything?</b>
      ${' '} Great question; thanks for asking! You should contact us at ${' '}
      <a
        href="mailto:listed.fun@gmail.com"
        target="_blank"
        onClick=${() => {
          Tracking.clickContact();
        }}
      >
        listed.fun@gmail.com
      </a>
      ${' '} if: you want to financially support, sponsor, or buy the game (hey Redfin and Zillow!);
      or you just want to reach out and say hello.
    </p>
  </section>
  <section class="modal__section">
    <p>
      <b>Thanks again,</b>
      ${' '} from Potch and Andrew!
    </p>
  </section>
`;

export default class ClosingDownModal extends Component {
  render({ show, onClose }) {
    return html`
      <${Modal}
        show=${show}
        key="modal--closing-down"
        onConfirm=${() => {
          Tracking.clickContact();
          window.open('mailto:listed.fun@gmail.com');
        }}
        confirmText="Say Hi"
        onClose=${onClose}
        closeText="Thanks"
        extraClassString="modal--closing-down"
      >
        <${ClosingDown} />
      </Modal>
    `;
  }
}
